import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

interface EmptyStateAction {
  label: string;
  onClick: () => void;
  primary?: boolean;
}

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: ReactNode;
  actions?: EmptyStateAction[];
  hint?: ReactNode;
  compact?: boolean;
}

export function EmptyState({ icon: Icon, title, description, actions, hint, compact }: EmptyStateProps) {
  return (
    <div className={`empty-state${compact ? ' empty-state-compact' : ''}`} role="status">
      <div className="empty-state-icon" aria-hidden="true">
        <Icon size={compact ? 20 : 28} strokeWidth={1.5} />
      </div>
      <div className="empty-state-body">
        <h4 className="empty-state-title">{title}</h4>
        <p className="empty-state-description">{description}</p>
        {actions && actions.length > 0 && (
          <div className="empty-state-actions">
            {actions.map((action) => (
              <button
                key={action.label}
                type="button"
                className={`btn btn-sm${action.primary ? ' btn-primary' : ''}`}
                onClick={action.onClick}
              >
                {action.label}
              </button>
            ))}
          </div>
        )}
        {hint && <p className="empty-state-hint">{hint}</p>}
      </div>
    </div>
  );
}
